module.exports = __webpack_public_path__ + "good_job_01.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/good_job_01.mp3
// module id = 663
// module chunks = 0